<template>
  <div style="color:white">
    <template v-if="!processingRegistration" >
      <h5>Registration Info</h5>
      <b-form-group>
        <label-info
            id="fullname"
            label-name="Full Name"
            label-info=""
            text-color="#FFFFFFFF"
            :is-required="true"
        />
        <b-form-input
            type="text"
            required
            v-model="formRegister.fullName"
            placeholder="Your Name"
        />
      </b-form-group>
      <b-form-group>
        <label-info
            id="email"
            label-name="Email"
            label-info=""
            text-color="#FFFFFFFF"
            :is-required="true"
        />
        <b-form-input
            type="email"
            required
            v-model="formRegister.email"
            placeholder="Email"
        />
      </b-form-group>
      <b-form-group>
        <label-info
            id="company-name"
            label-name="Company Name"
            label-info=""
            text-color="#FFFFFFFF"
            :is-required="false"
        />
        <b-form-input
            type="text"
            required
            v-model="formRegister.companyName"
            placeholder=""
        />
      </b-form-group>
      <b-form-group>
        <label-info
            id="company-website"
            label-name="Company Website"
            label-info=""
            text-color="#FFFFFFFF"
            :is-required="true"
        />
        <b-form-input
            type="text"
            required
            v-model="formRegister.companyWebsite"
            placeholder="http://"
        />
      </b-form-group>
      <b-form-group>
        <label-info
            id="city"
            label-name="City"
            label-info=""
            text-color="#FFFFFFFF"
            :is-required="true"
        />
        <b-form-input
            type="text"
            required
            v-model="formRegister.city"
            placeholder=""
        />
      </b-form-group>
      <b-form-group>
        <label-info
            id="country"
            label-name="Country"
            label-info=""
            text-color="#FFFFFFFF"
            :is-required="true"
        />
        <b-form-input
            type="text"
            required
            v-model="formRegister.country"
            placeholder=""
        />
      </b-form-group>
      <b-button
          @click="handleRegisterButtonClick"
          block
      >
        Register
      </b-button>
    </template>
    <div v-else class="text-center">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LabelInfo from "@/components/common/labelInfo";
export default {
  name: "Sessions_Registration_Form",
  components: {
    LabelInfo
  },
  props: {
    session: {
      type: Object,
      default: () => {
        return {}
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  mounted() {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    handleCloseOverlay(){
      this.$emit("close-registration-form");
    },
    handleRegisterButtonClick() {
      this.processingRegistration = true;

      if (this.userId) {
        this.formRegister._created_by = this.profileBy();
      }

      this.$store.dispatch("session/registerForSession",
          {
            session : this.session,
            form: this.formRegister,
          }
      ).then(res => {
        if (res) {
          if (this.profile) {
            this.saveUserRegistration();
          }
        }
      });
    },
    saveUserRegistration() {
      const formRegistration = {
        session: this.session,
        form: this.formRegister
      };

      let registrations = {
        registrations: [formRegistration]
      };

      this.$store
          .dispatch("user/updateAppUserData", {
            tool: {toolId: this.sessionsMyAppToolId, name:"Sessions"},
            data: registrations,
            key: 'registrations',
            viewingId: this.userId
          })
          .then(res => {
            //Email
            this.sendEmailConfirmation();
          })
          .catch(rej => {
            const notif = {
              description: rej.message,
              variant: "danger"
            };
            this.handleShowUserNotification(notif);
          });
    },
    sendEmailConfirmation(){
      let email = this.createEmailText({
        subject: 'You are confirmed',
        fromEmail:'sessions@heartbeatfam.com',
        toEmail: this.formRegister.email,
        emailText:"Congrats on your confirmation"
      });

      this.$store
          .dispatch("user/sendEmail", {emails :[email]})
          .then(res => {
            const notif = {
              description: 'Email Sent',
              variant: "success"
            };
            this.handleShowUserNotification(notif);
          })
          .catch(rej => {
            const notif = {
              description: rej.message,
              variant: "danger"
            };
            this.handleShowUserNotification(notif);
          });
    },
    handleShowUserNotification(notif){
      this.$store.dispatch("user/showNotification", {
        title: `${this.formSession.title} `,
        description: notif.description,
        variant: notif.variant
      });
      this.$bvModal.hide(this.modalId);
      this.resetForm();
    },
    profileBy() {
      return {
        uid: this.profile.userId,
        name: `${this.profile.firstname} ${this.profile.lastname}`,
        imgURL: this.profile.imgURL
      };
    },
    createEmailText({subject, fromEmail, toEmail, emailText}){
      return {
        "subject": subject,
        "from": {
          "email": fromEmail
        },
        "to": [
          {
            "email": toEmail
          }
        ],
        "text": emailText
      };
    }
  },
  data() {
    return {
      processingRegistration: false,
      processingStatus:"Registering ...",
      userId: this.profile && this.profile.userId ? this.profile.userId : null,
      sessionsMyAppToolId: 'd32gi61v3LTHd9jTPuwi',
      registerOverlay:{
        variant: 'dark',
        opacity:0.95,
        blur:'1rem',
      },
      formRegister:{
        fullName: this.profile && this.profile.firstname ?
            `${this.profile.firstname} ${this.profile.lastname ? this.profile.lastname : ''} `: "",
        email: this.profile && this.profile.email ? this.profile.email : '',
        companyName:null,
        companyWebsite: null,
        city: null,
        country: null
      },
      showRegistrationOverlay: false,
      sessionTitle: this.session && this.session.session &&
      this.session.session.title ? this.session.session .title : 'Title Error',
      sessionTopic: this.session && this.session.session  &&
      this.session.session.topic ? this.session.session.topic : '',
      mainPropsLogo: { blank: false, blankColor: '#777', class: 'm1' }
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
